import { LoaderIcon } from 'components/Icons/LoaderIcon';

export const PageLoader = () => (
  <div className="fixed left-0 top-0 z-50 flex h-full w-full items-center justify-center bg-lightPrimary/50">
    <LoaderIcon data-testid="page-loader-icon" />
  </div>
);
